import {
  buildAppReferralLink,
  buildPartnerJoinLink,
  buildReferralShareText,
  getFrontendAppBaseUrl,
} from "../../../../../infrastructure/utils/referralTracking";

export const PARTNER_LEVEL_LABELS = {
  Level1: "مدیر فروش",
  Level2: "کارشناس فروش",
};

export const PARTNER_TYPE_LABELS = {
  PublicReferrer: "معرف عمومی",
  ProfessionalPartner: "نماینده حرفه‌ای",
  TelecomPartner: "نماینده مخابراتی",
  LoanPartner: "نماینده وام",
  SettlementPartner: "نماینده تسویه",
};

export const PARTNER_TYPE_FORM_OPTIONS = {
  PublicReferrer: "معرف عمومی",
  ProfessionalPartner: "نماینده حرفه‌ای",
};

export const PARTNER_STATUS_LABELS = {
  PendingActivation: "در انتظار تایید",
  Active: "فعال",
  Suspended: "تعلیق‌شده",
  Inactive: "غیرفعال",
};

export const getPartnerStatusChipColor = (status) => {
  const normalized = String(status || "").toLowerCase();
  if (normalized === "active") return "success";
  if (normalized === "suspended") return "warning";
  if (normalized === "pendingactivation") return "info";
  if (normalized === "inactive") return "default";
  return "default";
};

export const isPartnerActive = (status) =>
  String(status || "").toLowerCase() === "active";

export const isPartnerPendingActivation = (status) =>
  String(status || "").toLowerCase() === "pendingactivation";

/** App referral link: {FrontendAppBaseUrl}/r/{code} e.g. https://app.solarent.ir/r/554 */
export const buildReferralLink = (referralCode) => buildAppReferralLink(referralCode);

/** Public sub-partner join link: {FrontendAppBaseUrl}/p/{code}/join */
export { buildPartnerJoinLink };

export const canShowPartnerJoinLink = (profile) =>
  String(profile?.partnerLevel ?? profile?.PartnerLevel ?? "").toLowerCase() ===
    "level1" &&
  Boolean(profile?.canCreateSubPartners ?? profile?.CanCreateSubPartners);

export { buildReferralShareText, getFrontendAppBaseUrl };

